import React, {useCallback, useContext, useMemo, useState} from "react";
import {BriefFormModal} from "../BriefFormModal/BriefFormModal.jsx";
import "./creation-brief-label.css";
import {Images} from "../../images/Images.jsx";
import {ConfigProvider, message, Tag} from "antd";
import {AppContext} from "../../AppContext.jsx";
import {GenericModal} from "../../components";
import {createBrief} from "../../api/briefs/briefs.js";
import {EditSubAdminModal} from "../../company/CompanyAccountProfile/EditSubAdminModal.jsx";
import {editSubAdminFields} from "../../company/CompanyAccountProfile/consts.jsx";
import {HttpClient} from "../../http/HttpClient.jsx";
import {editSubAdminPhoneHideFormFields} from "../../marketplace/MarketplaceBooking/ProductBooking/consts.js";
import {getLogger} from "../../Logger.jsx";

export const CreationBriefLabel = ({history}) => {
    const {me, services, fetchMe} = useContext(AppContext);
    const [visible, setVisible] = useState(false);
    const [createdBriefSuccessModalVisible, setCreatedBriefSuccessModalVisible] = useState(false);
    const [shouldUpdateSubAdminDetails, setShouldUpdateSubAdminDetails] = useState(false);
    const [isConfirmButtonLoading, setConfirmButtonLoading] = useState(false);

    const log = useMemo(() => getLogger({userId: me?.userId}, "CreationBriefLabel"), [me?.userId]);

    const onSaveBrief = useCallback(
        async values => {
            if (!me?.isCompanyMaster && !me?.phone) {
                setShouldUpdateSubAdminDetails(true);
                return;
            }

            const res = await createBrief(values);
            if (res.error) {
                return;
            } else {
                log("Brief created", {values});
                setVisible(false);
                setCreatedBriefSuccessModalVisible(true);
            }
        },
        [log, me?.isCompanyMaster, me?.phone]
    );

    const onClickOpenModal = useCallback(() => {
        setVisible(true);
        log("Brief modal label clicked", {});
    }, [setVisible, log]);

    const onSaveSubAdmin = useCallback(
        async ({phone}) => {
            setConfirmButtonLoading(true);

            const res = await HttpClient.safePut(`/api/users/${me?.userId}`, {phone, userId: me?.userId});

            setConfirmButtonLoading(false);

            if (res?.error) {
                message.error(res.error);
                return;
            }

            setShouldUpdateSubAdminDetails(false);
            fetchMe();
        },
        [me?.userId]
    );

    return (
        <>
            {!!me?.features?.brif && (
                <div className="creation-brief-label">
                    <div className="brief-button" onClick={onClickOpenModal}>
                        <img className="brief-icon" alt="brief-icon" src={Images.brifIcon} />
                        <div>
                            <div>
                                <span className="title">רוצים הצעת מחיר מותאמת אישית?</span>
                                <Tag className="brief-tag">חדש</Tag>
                            </div>
                            <div>תכתבו לנו כמה מילים, ותקבלו הצעה למייל</div>
                        </div>
                    </div>

                    <BriefFormModal
                        initValues={{}}
                        visible={visible}
                        onClose={() => setVisible(false)}
                        onSave={onSaveBrief}
                        disable={false}
                        hideFields={["serviceId"]}
                    />

                    <GenericModal
                        title="הבריף נשלח בהצלחה"
                        className="creation-brief-success-modal"
                        text={[
                            "אז מה בעצם קורה עכשיו?",
                            "הבריף התקבל במערכת וברגע שיתקבלו הצעות מחיר",
                            "נעדכן אותך במייל וסמס.",
                            "יהיה ניתן לעבור על ההצעות המחיר ולבחור את ההצעה המתאימה עבורך"
                        ]}
                        image={Images.handshake}
                        closeable={true}
                        visible={createdBriefSuccessModalVisible}
                        onClose={() => setCreatedBriefSuccessModalVisible(false)}
                        options={[
                            {
                                id: "continue-btn",
                                onClick: () => setCreatedBriefSuccessModalVisible(false),
                                text: "המשך גלישה באתר"
                            },
                            {
                                id: "briefs-page",
                                onClick: () => {
                                    history.push({
                                        pathname: `/company/profile/${me?.companyId}`,
                                        state: {activeKey: "7"}
                                    });
                                    setCreatedBriefSuccessModalVisible(false);
                                },
                                text: "לצפייה בבריפים"
                            }
                        ]}
                    />

                    {!me?.isCompanyMaster && (
                        <ConfigProvider direction="rtl">
                            <EditSubAdminModal
                                header="חסר לנו רק דבר קטן 📞"
                                subTitle="נראה שאין לנו את הטלפון שלך במערכת. כדי להשלים את הפעולה יש להזין אותו"
                                visible={shouldUpdateSubAdminDetails}
                                onSave={onSaveSubAdmin}
                                mainServices={services}
                                onClose={() => setShouldUpdateSubAdminDetails(false)}
                                subAdmin={me}
                                isConfirmButtonLoading={isConfirmButtonLoading}
                                hideFields={editSubAdminPhoneHideFormFields}
                            />
                        </ConfigProvider>
                    )}
                </div>
            )}
        </>
    );
};
